<template>
  <div class="view-container screen--center" v-if="providers">
    <MallAuthDialog v-if="show" :mallLimit="showMallLimit" @emitClose="closeDialog" />
    <div class="platform width-100">
      <div v-if="Object.keys(this.mallsObj).length === 0">
        <v-row no-gutters class="mt-5">
          <v-col cols="12" class="text-center">
            <p class="font--m-3">
              사입비 후불 결제를 희망하는
              <br />
              서비스를 연결해주세요
            </p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-5">
          <v-col cols="3">
            <img src="@/assets/images/step1.png" class="step1-img" alt="step1" />
          </v-col>
          <v-col cols="9" class="mb-1">
            <span class="font--m-4">계정 연동하기</span>
            <p class="font--m-8">
              플랫폼의 관리자계정을 연동하여 플랫폼에서
              <br />
              발생한 주문 목록을 불러 옵니다.
            </p>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-10">
          <v-col cols="3">
            <img src="@/assets/images/step2.png" class="step1-img" alt="step1" />
          </v-col>
          <v-col cols="9" class="mb-1">
            <span class="font--m-4">계약서 작성하기</span>
            <p class="font--m-8">
              플랫폼 연동이 완료되었다면
              <br />
              매출 채권 양수도 계약에 서명해주세요
              <br />
              <span class="font--m-7"
                >(*마이페이지 계약서 관리 메뉴를 통해 서명이 가능합니다.)</span
              >
            </p>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row no-gutters class="mt-5 mb-5">
          <v-col cols="12" class="text-center">
            <p class="font--m-5">
              플랫폼 계정을 연동하시면 <br />후불 결제 가능한 사입비 금액이 늘어납니다.
            </p>
          </v-col>
        </v-row>
      </div>
      <v-row no-gutters v-if="providers">
        <v-col cols="12">
          <p class="font--m-3 text-center mb-10">
            현재 연동 플랫폼 :
            <span class="font--m-3 color--buynow">{{ Object.keys(this.mallsObj).length }}</span> 개
          </p>
        </v-col>
        <v-col cols="12" class="text-center mb-5" v-for="mall in mergeMalls" :key="mall.code">
          <div class="mall">
            <v-avatar size="50">
              <img
                :src="mall.logo ? mall.logo : mall.logo404Path"
                @error="$event.target.src = mall.logo404Path"
              />
            </v-avatar>
            <span class="font--m-4 ml-5">{{ mall.name }}</span>
          </div>
          <template>
            <div
              class="mall-button"
              v-if="wrongCredentials.some((v) => v.mall.provider === mall.code)"
            >
              <BasicButton
                width="90px"
                height="40px"
                class="font--m-6"
                :to="{
                  path: `/my/malls/${mallsObj[mall.code].uuid}/form`,
                }"
                id="btn__EqwHcrwzHEKV3iJwlMJPIQ=="
              >
                정보 수정하기
              </BasicButton>
            </div>

            <div
              class="mall-button"
              v-else-if="is2faRequireds.some((v) => v.mall.provider === mall.code)"
            >
              <v-btn
                id="btn__zuRcqoi8nUuE1NiKSdBe2g=="
                style="background-color: #84e7c1"
                width="90px"
                height="40px"
                class="color--black font--m-7"
                @click="propsMallLimit(is2faRequireds.find((v) => v.mall.provider === mall.code))"
              >
                인증 정보 입력
              </v-btn>
            </div>

            <div class="mall-button" v-else-if="!!mallsObj[mall.code]">
              <BasicButton
                id="btn__VrSvvyqJ40Knoj4gOnCzBA=="
                width="90px"
                height="40px"
                class="font--m-6"
                :to="{
                  path: `/my/malls/${mallsObj[mall.code].uuid}/form`,
                }"
              >
                수정하기
              </BasicButton>
            </div>

            <div class="mall-button" v-else>
              <BasicButton
                id="btn__30QI7TdDjkSnekTTRCrQVQ=="
                width="90px"
                height="40px"
                class="font--m-6"
                color="green"
                :to="{ path: `/my/malls/form`, query: { provider: mall.code } }"
              >
                연동하기
              </BasicButton>
            </div>

            <!-- <div class="mall-button" v-else-if="mall.isAvailable === false">
                <BasicButton
                  width="90px"
                  height="40px"
                  class="font--m-6"
                  :disabled="mall.isAvailable === false"
                >
                  준비중
                </BasicButton>
              </div> -->
          </template>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-10">
        <v-col cols="12" class="text-center">
          <p class="font--m-5">
            추가로 연동되길 희망하는 플랫폼이 있다면 <br />
            바이나우에 알려주세요!
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import MallAuthDialog from '@/components/mall/MallAuthDialog.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: { MallAuthDialog },
  data() {
    return {
      providers: null,
      show: false,
      showMallLimit: null,
    }
  },
  computed: {
    ...mapGetters('mall', ['mallsObj']),
    ...mapState('mall', ['malls']),
    ...mapState('bnpl', ['availableAmount', 'wrongCredentials', 'is2faRequireds']),
    availableProviders() {
      return this.providers.filter((v) => v.isAvailable === true)
    },
    linkingMalls() {
      const results = this.availableProviders.filter((v) => {
        const result = this.malls?.find((vv) => {
          return v.code === vv.provider
        })
        return !!result
      })

      return results
    },
    unlinkingMalls() {
      const results = this.availableProviders.filter((v) => {
        const result = this.malls?.find((vv) => {
          return v.code === vv.provider
        })
        return !!!result
      })

      return results
    },
    mergeMalls() {
      const results = this.linkingMalls.concat(this.unlinkingMalls)
      return results
    },
  },
  async created() {
    this.getAvailableAmount()
    this.providers = await this.getMallProviders()
    this.getMalls()
    this.getContracts()
  },
  methods: {
    ...mapActions('mall', ['getMalls', 'getMallProviders']),
    ...mapActions('bnpl', ['getAvailableAmount']),
    ...mapActions('contract', ['getContracts']),
    closeDialog() {
      setTimeout(() => {
        this.show = false
      }, 50)
    },
    propsMallLimit(temp) {
      this.showMallLimit = temp
      this.show = true
    },
  },
}
</script>
<style lang="scss" scoped>
.mall {
  float: left;
}
.mall-button {
  float: right;
}
</style>
